export default "__VITE_ASSET__a8a83a5a__"